// extracted by mini-css-extract-plugin
export default {"cards":"Index_cards__FH+k-","card":"Index_card__6-5hu","top":"Index_top__Y3d82","title":"Index_title__st-B4","result":"Index_result__zhGij","welcome":"Index_welcome__H1KRR"};